import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const ir = {
    jpath: ['spectra', 'ir'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default ir;
//# sourceMappingURL=ir.js.map